import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CheckmarkCircle } from '../../../../assets/icons/checkmark-circle.svg'
import { useResponsesStore } from '../../../../stores/responsesStore'

import styles from './add-response-key.module.scss'

function AddResponseKey() {
    const { t } = useTranslation()

    const [{ responses, newResponseId }, { addResponse }] = useResponsesStore()

    const [newResponse, setNewResponse] = useState('')

    const handleAddResponse = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        if (!newResponse) return

        if (
            newResponseId ||
            !newResponse ||
            responses?.filter((response) => response.name === newResponse)
                .length
        ) {
            return
        }

        addResponse(newResponse)

        setNewResponse('')
    }

    return (
        <form className={styles.addResponseKey} onSubmit={handleAddResponse}>
            <input
                className={styles.addResponseKey__input}
                type="text"
                id="response"
                value={newResponse}
                placeholder={t('key')}
                onChange={(e) => setNewResponse(e.target.value)}
            />
            <button className={styles.addResponseKey__addBtn} type="submit">
                <CheckmarkCircle alt={t('add')} />
                {t('confirm')}
            </button>
        </form>
    )
}

export default AddResponseKey
